import { render } from "./HistoryBack.vue?vue&type=template&id=45ac6869"
import script from "./HistoryBack.vue?vue&type=script&lang=js"
export * from "./HistoryBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__